import { useAppSelector } from "@app/hooks";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { AccountDetails } from "../components/AccountDetails";
import { AccountLocations } from "../components/AccountLocations/AccountLocations";
import { AccountPlans } from "../components/AccountPlans";

export const ManageOverview = (): JSX.Element => {
    const organization = useAppSelector((x) => x.organization);
    const { isClinicalAdmin } = useUserPermission({ useCurrentLocation: true });

    return (
        <>
            <AccountDetails organization={organization} />
            {isClinicalAdmin && <AccountPlans />}
            <AccountLocations />
        </>
    );
};
